// app/javascript/controllers/clipboard_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "toast"]

  async copy() {
    try {
      const text = this.sourceTarget.value
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text)
      } else {
        // Fallback for older browsers
        this.sourceTarget.classList.remove("sr-only")
        this.sourceTarget.select()
        document.execCommand("copy")
        this.sourceTarget.classList.add("sr-only")
      }
      this._flash("Copied!")
    } catch (e) {
      this._flash("Copy failed")
      // eslint-disable-next-line no-console
      console.error(e)
    }
  }

  _flash(msg) {
    if (!this.hasToastTarget) return
    this.toastTarget.textContent = msg
    this.toastTarget.classList.remove("hidden")
    clearTimeout(this._t)
    this._t = setTimeout(() => this.toastTarget.classList.add("hidden"), 1400)
  }
}
